import { domContentLoadEvent } from '../common/domContentLoadEvent';
import { getTranslatedMessages } from '../translates';
import { closeModal, openModal } from './modal/simple-modal';

let checkoutItems = [];
let btnsAddItem = document.querySelectorAll('.add-cart-item');
let btnsRemoveItem = document.querySelectorAll('.remove-cart-item');
let btnsRemoveAll = null;
const isCheckout = document.querySelector('.page-staramania-checkout');
const totalPrice = document.querySelector('.total-price');
const inputProducts = document.querySelector('input[name="products"]');

function addZeroes(num) {
    var num = Number(num);
    if (isNaN(num)) {
        return 0;
    }
    if (String(num).split(',').length < 2 || String(num).split(',')[1].length <= 2) {
        num = num.toFixed(2);
    }
    return num;
}

function checkCart() {
    const cartItems = localStorage.getItem('cartItems');
    checkoutItems = cartItems ? JSON.parse(cartItems) : [];

    if (isCheckout) {
        inputProducts.value = JSON.stringify(checkoutItems);
        if (inputProducts.value == '[]') {
            document.querySelector(
                '.cart-items'
            ).innerHTML = `<div class="text-2xl text-dark lg:py-24 py-12 block font-extrabold text-center">${
                getTranslatedMessages().emptyCartStaramania
            }</div>`;
        } else {
            checkoutItems.forEach((element) => {
                document.querySelector('.cart-items').insertAdjacentHTML(
                    'beforeend',
                    `
                <div data-id="${
                    element.id
                }" class="item-cart flex xl:justify-between md:justify-center items-center md:pt-11 pb-11 md xl:px-28 lg:px-14 pt-6 px-5 rounded-b-xl flex-wrap relative">
                    <span class="text-dark dark:text-primary-dark font-extrabold text-base lg:hidden block mb-5">${
                        element.name
                    }</span>

                    <span class="text-dark dark:text-primary-dark block font-extrabold lg:text-2xl text-xl absolute left-7 bottom-10 lg:hidden">
                    R$ ${addZeroes(element.price).replace('.', ',')}</span>
                    <div class="xl:w-[750px] lg:w-[550px] w-full flex justify-between relative">
                    
                        <img class="xl:w-[260px] lg:w-48 xl:mr-0 lg:mr-[50px] mr-4 w-[120px] h-auto object-cover" src="${
                            element.image
                        }">


                        <div class="xl:max-w-[440px] lg:max-w-[308px] w-full">
                            <span class="text-dark dark:text-primary-dark font-extrabold text-2xl lg:block hidden mb-5">${
                                element.name
                            }</span>
                            <textarea class="bg-white rounded-xl text-[14px] p-5 border-2 border-primary dark:border-primary-dark lg:h-[160px] h-28 w-full mr-20 resize-none" placeholder="${
                                getTranslatedMessages().placeholderStaramania
                            }" data-id="${element.id}" value="${element.obs}"></textarea>
                        </div>
                    </div>
                    <div class="flex lg:justify-center justify-end lg:mt-0 mt-3 lg:w-[250px] w-full xl:ml-0 lg:ml-[50px] flex-wrap relative lg:top-8 items-center">
                        <button data-id="${
                            element.id
                        }" class="remove-cart-item btn btn-primary rounded-top tracking-normal text-white dark:text-dark-dark flex justify-center items-center text-base md:w-12 md:h-12 w-9 h-9">-</button>
                        <div class="bg-white dark:bg-dark-dark rounded-xl border-2 border-primary dark:border-primary-dark md:w-[100px] w-[70px] h-11 flex justify-center items-center mx-[10px]">
                            <span class="quantity dark:text-primary-dark text-black font-extrabold text-2xl">${
                                element.quantity
                            }</span>
                        </div>
                        <button class="add-cart-item tracking-normal btn btn-primary rounded-top text-white dark:text-dark-dark flex justify-center items-center text-base md:w-12 md:h-12 w-9 h-9" data-quantity="1" data-price="${
                            element.price
                        }" data-name="${element.name}"  data-id="${element.id}">+</button>
                        <button class="remove-items tracking-3 text-primary dark:text-primary-dark text-xs hidden lg:flex justify-center items-center w-full h-12 mt-3" data-quantity="${
                            element.quantity
                        }" data-price="${element.price}" data-id="${element.id}">
                            <span class="underline">
                                ${getTranslatedMessages().removeProductStaramania}
                            </span>
                        </button>

                        <span class="text-dark dark:text-primary-dark lg:block font-extrabold text-2xl  mt-7 hidden">
                        R$ ${addZeroes(element.price).replace('.', ',')}</span>
                    </div>
                </div>
            `
                );
                btnsAddItem = document.querySelectorAll('.add-cart-item');
                btnsRemoveItem = document.querySelectorAll('.remove-cart-item');
                btnsRemoveAll = document.querySelectorAll('.remove-items');
            });
        }
    } else {
        document.querySelector('.btn-cart .badge').innerHTML = getTotalItems();
    }

    getTotalPrice();
    events();
}

function getTotalItems() {
    let quantityArray = [];
    checkoutItems.forEach((element) => {
        quantityArray.push(Number(element.quantity));
    });

    return quantityArray.reduce((a, b) => a + b, 0);
}

function getTotalPrice() {
    let totalPriceArray = [];
    checkoutItems.forEach((element) => {
        totalPriceArray.push(Number(element.quantity * element.price));
    });

    const total = totalPriceArray.reduce((a, b) => a + b, 0);

    if (isCheckout) {
        totalPrice.innerHTML = '';
        totalPrice.insertAdjacentHTML('beforeend', 'R$ ' + total.toFixed(2).replace('.', ','));
    }
}

function addToCart(id, quantity, price, image, obs, name) {
    const item = checkoutItems.filter((elem) => elem.id == id);
    if (item.length > 0) {
        item[0].quantity = Number(item[0].quantity) + 1;
    } else {
        checkoutItems.push({
            id: id,
            quantity: quantity,
            price: price,
            image: image,
            obs: obs,
            name: name,
        });
    }

    saveCheckout(id);
}

function removeFromCart(id, quantity) {
    if (checkoutItems != [] || !checkoutItems) {
        checkoutItems.forEach((element, index) => {
            if (element.id == id) {
                element.quantity = Number(element.quantity) - quantity;
                if (element.quantity <= 0) {
                    checkoutItems.splice(index, 1);
                    document.querySelectorAll('.item-cart').forEach((item) => {
                        const idElement = item.getAttribute('data-id');
                        if (idElement == element.id) {
                            item.remove();
                        }
                    });
                }
            }
        });

        saveCheckout(id);
    }
}

//TODO: atualziar a página nessa função
function saveCheckout(id) {
    localStorage.setItem('cartItems', JSON.stringify(checkoutItems));
    if (!isCheckout) {
        document.querySelector('.btn-cart .badge').innerHTML = getTotalItems();
    } else {
        inputProducts.value = JSON.stringify(checkoutItems);
        checkoutItems.forEach((element, index) => {
            if (element.id == id) {
                document.querySelectorAll('.item-cart').forEach((item) => {
                    const idElement = item.getAttribute('data-id');
                    if (idElement == element.id) {
                        item.querySelector('.quantity').innerHTML = element.quantity;
                        item.querySelector('.remove-items').setAttribute('quantity', element.quantity);
                    }
                });
            }
        });

        if (inputProducts.value == '[]') {
            document.querySelector(
                '.cart-items'
            ).innerHTML = `<div class="text-2xl text-dark lg:py-24 py-12 block font-extrabold text-center">${
                getTranslatedMessages().emptyCartStaramania
            }</div>`;
        }
    }
}

function events() {
    btnsAddItem.forEach((element) => {
        element.addEventListener('click', function () {
            const id = element.getAttribute('data-id');
            const quantity = Number(element.getAttribute('data-quantity'));
            const price = element.getAttribute('data-price');
            const image = element.getAttribute('data-image');
            const obs = element.getAttribute('data-obs');
            const name = element.getAttribute('data-name');
            addToCart(id, quantity, price, image, obs, name);
            saveCheckout();
            getTotalPrice();
        });
    });

    if (isCheckout) {
        btnsRemoveItem.forEach((element) => {
            element.addEventListener('click', function () {
                const id = element.getAttribute('data-id');

                removeFromCart(id, 1);
                saveCheckout();
                getTotalPrice();
            });
        });

        if (btnsRemoveAll) {
            btnsRemoveAll.forEach((element) => {
                element.addEventListener('click', function (e) {
                    const id = element.getAttribute('data-id');
                    const quantity = element.getAttribute('data-quantity');

                    console.log(quantity);
                    removeFromCart(id, Number(quantity));
                    saveCheckout();
                    getTotalPrice();
                });
            });
        }
    } else {
        document.querySelector('.add-cart-product').addEventListener('click', function () {
            openModal('.modal-added-to-cart');
        });

        document.querySelectorAll('.modal-added-to-cart .close-modal').forEach((element) => {
            element.addEventListener('click', function () {
                closeModal('.modal-added-to-cart');
            });
        });
    }
}

domContentLoadEvent(checkCart, getTotalPrice);
